<template>
    <div v-if="filteredListLength">
        <b-alert show class="mb-4">
            <div class="d-flex justify-content-around">
                <div>
                    Samples in Query: {{ filteredListLength }} 
                </div>
                <div>
                    Samples in schedule: {{  sampleCount }}
                </div>
            </div>
        </b-alert>
    </div>
</template>

<script>
import ScheduleModel from "@/models/lab/ScheduleModel";

export default {
    name: "SampleCohortQueryBanner",
    props: {
        filteredListLength: {
            type: Number,
            required: true
        },
        scheduleModel: {
            type: ScheduleModel,
            required: true
        },
        updateSampleLength: {
            type: Number
        }
    },
    data() {
        return {
            sampleCount: 0,
            schedule: null,
        };
    },
    methods: {
        getSampleCount() {
            return this.schedule.samples_count;
        },
    },
    created() {
        this.schedule = this.scheduleModel.attributes
        this.sampleCount = this.getSampleCount()
    },
    watch: {
        updateSampleLength: {
            handler() {
                this.sampleCount = this.updateSampleLength;
            }
        }
    }
};
</script>